import { useCallback } from 'react';
import { compareWithAppVersion } from '@croquiscom-pvt/web2app';
import getConfig from 'next/config';

import { ZigzagEvent } from '@common/app-manager';
import { isZigzag } from '@common/device-manager';

import { PopupViewType } from '../constants/PopupViewType';
import { useCatalogProductIdParams } from './useCatalogProductIdParams';
const config = getConfig().publicRuntimeConfig.config;

type QueryParams = Record<string, string | number | boolean>;

/**
 * PDP 부분네이티브(DETAIL_BROWSER)에서만 showPopup을 사용할 수 있도록 제한
 * PDP 내부에서만 해당 기능 사용 제한
 */
function isValidCatalogUrl() {
  try {
    const urlObj = new URL(location.href);
    const productsPattern = /^(\/app)?\/products\/\d+\/.*/;
    const pathPattern = /^(\/app)?\/catalog\/products\/\d+$/;

    // 풀네이티브 PDP에서 사용하는 웹뷰 패턴인 경우에는 허용한다.
    if (productsPattern.test(urlObj.pathname)) return true;

    // 부분네이티브 PDP의 경우 허용한다.
    if (pathPattern.test(urlObj.pathname) && urlObj.searchParams.get('browsing_type') === 'DETAIL_BROWSER') {
      return true;
    }

    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export const usePopupView = () => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const showPopup = useCallback((viewType: PopupViewType, fallback?: () => void, queryParams?: QueryParams) => {
    if (!PopupViewType[viewType]) return;
    const url = `${config.appUrl}/products/${catalog_product_id}/popup?type=${PopupViewType[viewType]}${
      queryParams ? `&${jsonToQueryParam(queryParams)}` : ''
    }`;
    const enableAppPopup = isZigzag() && compareWithAppVersion('7.75.0') && isValidCatalogUrl();
    if (enableAppPopup) {
      return ZigzagEvent.showPopup(url);
    }

    fallback?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    showPopup,
  };
};

function jsonToQueryParam(json: QueryParams): string {
  return Object.entries(json)
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value));
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');
}
